var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgListings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 106,
    height: 106,
    viewBox: "0 0 106 106",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#71E3E2",
    strokeWidth: 5,
    d: "M17.029 62.235L6.217 60.078A4 4 0 0 1 3 56.155v-6.31a4 4 0 0 1 3.217-3.923l10.812-2.16a36.907 36.907 0 0 1 4.03-9.704l-6.13-9.131a4 4 0 0 1 .492-5.058l4.447-4.448a4 4 0 0 1 5.06-.492l9.128 6.132a36.907 36.907 0 0 1 9.756-4.044L45.93 6.229A4 4 0 0 1 49.855 3h6.29a4 4 0 0 1 3.925 3.229l2.12 10.789a36.907 36.907 0 0 1 9.754 4.043l9.129-6.132a4 4 0 0 1 5.059.492l4.447 4.448a4 4 0 0 1 .493 5.058l-6.132 9.131a36.907 36.907 0 0 1 4.043 9.754l10.788 2.118A4 4 0 0 1 103 49.855v6.29a4 4 0 0 1-3.229 3.925l-10.789 2.12a36.906 36.906 0 0 1-4.017 9.71l6.12 9.176a4 4 0 0 1-.498 5.048l-4.463 4.462a4 4 0 0 1-5.048.499l-9.173-6.121a36.906 36.906 0 0 1-9.668 4.007l-2.157 10.812A4 4 0 0 1 56.155 103h-6.31a4 4 0 0 1-3.923-3.217l-2.16-10.812a36.907 36.907 0 0 1-9.665-4.007l-9.173 6.121a4 4 0 0 1-5.048-.499l-4.463-4.462a4 4 0 0 1-.499-5.048l6.121-9.176a36.906 36.906 0 0 1-4.006-9.665zM53 68.347c8.476 0 15.347-6.871 15.347-15.347 0-8.476-6.871-15.347-15.347-15.347-8.476 0-15.347 6.871-15.347 15.347 0 8.476 6.871 15.347 15.347 15.347z"
  })));
}

export default SvgListings;